import * as React from "react";
import InputField from "../../generic/inputField";
import { emailRegex, pan, phoneNo, alphaNumExp, integerExp } from "../../utils/regex";
import EdButton from "../../generic/edButton";
import RadioButton from "../../generic/radioButton";
import "../../../assets/scss/Login/login/forms/forgotLoginIdForm.scss";
import "../../../assets/scss/Login/login/generic/loginInput.scss";
import { IListObj } from "../../types/genericTypes";
import LoginErrMsg from "../generic/loginErrMsg";
import { AForgotLoginId } from "../../../services/login/loginApiService";
import loginURLConfig from "../../../config/login/loginURLConfig";

export interface IForgotLoginIdFormProps {
	onSuccess: (msg: string) => void; // function to be called on the success of called apis
}

// form fields
export interface IForgotLoginIdFields {
	pan: string;
	email: string;
	mobile: string;
	accTyp: string;
}

const ForgotLoginIdForm: React.FC<IForgotLoginIdFormProps> = (props) => {
	// used to store the entered values in form
	const [values, setValues] = React.useState<IForgotLoginIdFields>({ pan: "", email: "", mobile: "", accTyp: "EQ" });

	// used to store the field wise errors
	const [errors, setErrors] = React.useState<{ [key in keyof IForgotLoginIdFields]?: string }>({
		pan: undefined,
		email: undefined,
		mobile: undefined
	});

	// used to store the error message that comes from api
	const [errorMsg, setErrorMsg] = React.useState("");

	// used to store if the form is submitted or not
	const [submitted, setSubmitted] = React.useState(false);

	const accTyp: Array<IListObj> = [
		{ value: "EQ", display: "Equity" },
		{ value: "CO", display: "Commodity" }
	];

	function handleSubmit(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
		e.preventDefault();
		setSubmitted(true);
		AForgotLoginId(forgotLoginIdRes, { ...values, mode: "BOTH" });
	}

	function forgotLoginIdRes(res: any) {
		if (res.data) {
			// if success, then call the onSuccess function in prop
			props.onSuccess(res.data.msg);
		} else if (res.error) {
			// else enable form again
			setSubmitted(false);

			if (res.error.errCd === "ELGH0001") {
				// show account type radio
				setValues({ ...values, accTyp: "EQ" });
			} else {
				// hide account type radio and error msg block
				// const { pan, email, mobile, accTyp } = values;
				// setValues({ pan, email, mobile, accTyp });
				setErrorMsg(res.error.errMsg);
			}
		}
	}

	function onChange(key: keyof IForgotLoginIdFields, value: string) {
		// onchange of any field remove both type of errors
		if ((key === "pan" && !alphaNumExp.test(value)) || (key === "mobile" && !integerExp.test(value))) {
			value = values[key];
		}
		if(key =="accTyp"){
			setErrors({...errors, pan: "", email: "", mobile: ""});
			setValues({ pan: "", email: "", mobile: "", accTyp: value});
		}else{ 
			setErrors({ ...errors, [key]: "" });
			setValues({ ...values, [key]: value });
		}
		setErrorMsg("");
		return value;
	}

	return (
		<form className="login_form">
			<div className="same_acc mg-b30">
				{/* <p className="inp_lbl mg-b15">Account type</p>
				<ul className="same_acc_radio mg-b45">
				<li className="list_Item">
					{accTyp.map((typ) => (
					<RadioButton
						key={typ.value}
						list={typ}
						name={"sameAcc"}
						selected={values.accTyp}
						onChange={() => onChange("accTyp", typ.value as string)}
					/>
					))}
				</li>
				</ul> */}
			</div>
			<label className="inp_lbl mg-b5 ib">PAN No.</label>
			<InputField
				defaultValue = {values.pan}
				onChange={(pan) => onChange("pan", pan)}
				onBlur={(error) => setErrors({ ...errors, pan: error.pattern ? "" : "Please enter a valid PAN" })}
				className="login_inp mg-b40"
				placeholder="Eg: JUKL5678987"
				helpTextColor="blue"
				required
				pattern={pan}
				errorText={errors.pan}
				maxLength={10}
			/>

			{(values.accTyp =="EQ" || !loginURLConfig.CommKambala) && (
				<>
				<label className="inp_lbl mg-b5 ib">Email ID</label>
				<InputField
					defaultValue = {values.email}
					pattern={emailRegex}
					required
					onChange={(email) => onChange("email", email)}
					onBlur={(error) => setErrors({ ...errors, email: error.pattern ? "" : "Please enter a valid email address" })}
					className="login_inp mg-b40"
					placeholder="Eg: sarveshpali@gmail.com"
					errorText={errors.email}
				/>
				</>
			)}

			<label className="inp_lbl mg-b5 ib">Phone Number</label>
			<div className="phone_no">
				<span className="cntry_code mg-b40 ib mg-r20">+91</span>
				<InputField
					defaultValue = {values.mobile}
					type="tel"
					onChange={(mobile) => onChange("mobile", mobile)}
					onBlur={(error) => setErrors({ ...errors, mobile: error.pattern ? "" : "Please enter a valid phone number" })}
					className="login_inp mg-b40"
					placeholder="Eg: 9809807765"
					pattern={phoneNo}
					errorText={errors.mobile}
					maxLength={10}
				/>
			</div>

			{/* This select account type block will only show if "ELGH0001" error comes in response to api */}
			{/* {values.accTyp && (
				<div className="same_acc">
					<p className="inp_lbl mg-b15">Select Account type to retrieve Login ID:</p>
					<ul className="same_acc_radio mg-b45">
						<li className="list_Item">
							{accTyp.map((typ) => (
								<RadioButton
									key={typ.value}
									list={typ}
									name={"sameAcc"}
									selected={values.accTyp}
									onChange={() => onChange("accTyp", typ.value as string)}
								/>
							))}
						</li>
					</ul>
				</div>
			)} */}

			{/* Show error if any */}
			{errorMsg && <LoginErrMsg className="mg-b40">{errorMsg}</LoginErrMsg>}

			<EdButton
				value="Retrieve Login ID"
				btnTyp="primary"
				className="submit_btn"
				// Disable if there is even one error or if any field is empty or if form is submitted
				disabled={Object.values(errors).some((error) => error) || 
					((values.accTyp =="EQ"|| !loginURLConfig.CommKambala) ? (Object.values(values).some((value) => !value)) : (!values.mobile || !values.pan)) || submitted}
				onClick={handleSubmit}
			/>
		</form>
	);
};

export default ForgotLoginIdForm;
